/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useContext, useEffect } from 'react';
import parse from 'html-react-parser';
import Input from './common/Input';
import { Pencil, XSquare } from 'react-bootstrap-icons';
import { Link } from "react-router-dom";
import { Badge, Form } from 'react-bootstrap';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { useForm } from "react-hook-form";
import ImageUploader from './common/UploadImage';


const Generals = () => {

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);
    const [catId, setCatId] = useState('');
    const [imgUrl, setImgUrl] = useState('');
    const [selectedImages, setSelectedImages] = useState([]);
    const [uploadButtonDisabled, setUploadButtonDisabled] = useState(true);


    const fetchClient = () => {
        coreContext.fetchSelfGenerals(authContext.itemId);
        coreContext.fetchGeneralCategories(authContext.itemId);
    }

    const { register: registerGeneral, handleSubmit: handleSubmitGeneral, errors: errorsGeneral, setValue: setValueGeneral } = useForm({});
    const { register: registerCategory, handleSubmit: handleSubmitCategory, errors: errorsCategory, setValue: setValueCategory } = useForm({});

    useEffect(fetchClient, []);

    const populateClient = () => {
        setValueGeneral('title', coreContext.client.general_title);
        setValueGeneral('message', coreContext.client.general_message);
        setValueCategory('category_name', coreContext.client.general_category_name);
        setValueCategory('sub_categories', coreContext.client.general_sub_categories);
    }

    useEffect(populateClient, [coreContext.client]);

    const deleteGeneral = (id) => {
        const r = confirm("Delete Item ?");
        if (r === true) {
            coreContext.deleteGeneral(id, coreContext.client.id);
        } else {

        }
    }

    const resetGeneralCategory = () => {
        setValueCategory('category_name', '');
        setValueCategory('sub_categories', '');
        setCatId('');
        setImgUrl('');
        setSelectedImages([]);
    }

    const deleteGeneralCategory = (id) => {
        const r = confirm("Delete Item ?");
        if (r === true) {
            coreContext.deleteGeneralCategory(id, coreContext.client.id);
        } else {

        }
    }

    const getCatName = (id) => {
        const cat = coreContext.generalCategories.find(cat => cat.id === id);
        return cat ? cat.name : '';
    }


    const renderGenerals = () => {
        const generals = coreContext.generals;
        if (generals)
            return generals.map(general => <tr key={general.id}><td>{general.title}</td><td>{parse(general.message)}</td><td>{general.edate}</td><td>{getCatName(general.cat_id)}</td><td>{general.displayOrder}</td><td><Link className="btn btn-primary btn-sm" title='Edit general' to={`/general/${general.id}`}><Pencil size="12" /></Link></td><td><button onClick={() => deleteGeneral(general.id)} type="button" className="btn btn-danger btn-sm" title="Delete Item"> <XSquare size="12" /> </button></td></tr>)
    }

    const changeImgUrl = (url) => {
        if (url)
            setImgUrl('http://' + url);
        else setImgUrl('');
    }

    const showImgUrl = (url) => {
        if (url)
            return 'https://' + url;
        else return '';
    }

    const renderGeneralCategories = () => {
        const generals = coreContext.generalCategories;
        if (generals)
            return generals.filter(general => general.id != '0').map(general => <tr key={general.id}><td>{general.name}</td><td>{general.subCategoryNames}</td><td><img src={showImgUrl(general.imgUrl)} alt="" style={{ width: '50px', height: '50px' }} /></td><td><Link className="btn btn-primary btn-sm" title='Edit general category' to={`#`} onClick={() => { setValueCategory('category_name', general.name); setValueCategory('sub_categories', general.subCategoryNames); setCatId(general.id); changeImgUrl(general.imgUrl) }}><Pencil size="12" /></Link></td><td><button onClick={() => deleteGeneralCategory(general.id)} type="button" className="btn btn-danger btn-sm" title="Delete Item"> <XSquare size="12" /> </button></td></tr>)
    }


    const onGeneralSectionHandler = (data) => {
        coreContext.updateGeneralSection(data.title, data.message, authContext.itemId);
    }

    const onGeneralSectionCategoryHandler = async (data) => {
        const count = selectedImages.length;
        if (count > 1) { alert('Only one image should be uploaded for this section !'); return; }
        let counter = 0;

        for (const image of selectedImages) {
            ++counter;
            const formData = new FormData();
            formData.append('category_name', data.category_name);
            formData.append('sub_categories', data.sub_categories);
            formData.append('itemId', authContext.itemId);
            formData.append('userId', coreContext.client.id);
            formData.append('catId', catId);
            formData.append('image', image, image.name);
            await coreContext.updateGeneralSectionCategory(formData, authContext.itemId);

            // coreContext.updateGeneralSectionCategory(data.category_name, data.sub_categories, authContext.itemId, coreContext.client.id, catId);
        }

    }


    const onImagesSelected = (pictures) => {
        setSelectedImages(pictures);
        //  console.log(pictures);
        if (pictures.length > 0) setUploadButtonDisabled(false); else setUploadButtonDisabled(true);
    }


    return (<div className='container-fluid'>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">General Section</Badge></h3></div>
            <div className="row">
                <div className="col-md-9">
                    <h5><Badge variant="success">Add General Section</Badge></h5>
                    <div className="card-body">
                        <Form autoComplete='off' onSubmit={handleSubmitGeneral(onGeneralSectionHandler)} noValidate>
                            <Input label='Title' name='title' minLength={2} maxLength={155} required={false} register={registerGeneral} errors={errorsGeneral} elementType='textarea' placeholder='Enter Title' />

                            <Input label='Image Message' name='message' minLength={2} maxLength={2000} required={false} register={registerGeneral} errors={errorsGeneral} elementType='textarea' placeholder='Enter Message' />

                            <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp; {coreContext.renderLoader()} &nbsp;&nbsp;
                            <Input variant='danger' label={coreContext.message} elementType='label' />
                            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; <Link to="/add-general">Add General Item</Link>
                        </Form>
                    </div>
                </div>
                <div className="col-md-3" style={{ height: '400px', overflowY: 'scroll' }}>
                    <h5><Badge variant="success">Add General Section Category</Badge></h5>
                    <div className="card-body">
                        <Form autoComplete='off' onSubmit={handleSubmitCategory(onGeneralSectionCategoryHandler)} noValidate>
                            <Input label='Name' name='category_name' minLength={2} maxLength={155} required={true} register={registerCategory} errors={errorsCategory} elementType='textarea' placeholder='Enter Category Name' />

                            <Input label='SubCategories' name='sub_categories' minLength={2} maxLength={250} required={false} register={registerCategory} errors={errorsCategory} elementType='textarea' placeholder='Enter SubCategories, seperated by comma' />

                            {imgUrl && <img style={{ width: '100px', height: '100px' }} src={imgUrl} alt="" />}

                            <ImageUploader onImagesSelected={onImagesSelected} maxWidthOrHeight='1920' pictures={selectedImages} />

                            <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp; {coreContext.renderLoader()} &nbsp;&nbsp;
                            {catId && <Input buttonType='button' elementType='button' variant='danger' onClick={() => resetGeneralCategory()} value="Reset" />}
                        </Form>
                    </div>
                </div>
            </div>
        </div>
        <div className="card">
            <div className="row">
                <div className="col-md-8">
                    <div className="card-title mx-auto"><h4><Badge variant="success">Available General Sections</Badge></h4></div>
                    <div className="card-body">
                        <table className="table table-bordered table-sm">
                            <thead>
                                <tr><th>Title</th><th>Message</th><th>Date</th><th>Category</th><th>Inverse Display Order</th><th></th><th></th></tr>
                            </thead>
                            <tbody>
                                {renderGenerals()}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card-title mx-auto"><h4><Badge variant="success">Available General Section Categories</Badge></h4></div>
                    <div className="card-body">
                        <table className="table table-bordered table-sm">
                            <thead>
                                <tr><th>Name</th><th>SubCategories</th><th>Img</th><th></th><th></th></tr>
                            </thead>
                            <tbody>
                                {renderGeneralCategories()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export { Generals }